import React from 'react';

const LazyDelay = imp => React.lazy(() => {
    return Promise.all([
        imp,
        new Promise(resolve => setTimeout(resolve, 900))
    ])
        .then(([moduleExports]) => moduleExports);
});
export default LazyDelay;